<footer>
    <img src="../../../assets/Group 34.svg" alt="">
</footer>